module.exports = __webpack_public_path__ + "img/lg_ring_g_skip_0_0@2x.d10958b8.png";